<template>
  <card>
    <h4 slot="header" class="card-title">İşletme Düzenle</h4>
    <a-form-model
      ref="ruleForm"
      :model="corporation"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
      labelAlign="left"
    >
      <a-form-model-item ref="corporation_name" label="İşletme Adı" prop="corporation_name">
        <a-input
          placeholder="İşletme Adı"
          v-model="corporation.corporation_name"
          @blur="() => { $refs.corporation_name.onFieldBlur(); }"
        />
      </a-form-model-item>

      <a-form-model-item ref="owner_name" label="İşletme Sahibi" prop="owner_name">
        <a-input
          placeholder="İşletme Sahibi Adı"
          v-model="corporation.owner_name"
          @blur="() => { $refs.owner_name.onFieldBlur(); }"
        />
      </a-form-model-item>

      <a-form-model-item ref="phone_number" label="Telefon" prop="phone_number">
        <a-input placeholder="Telefon Numarası" v-model="corporation.phone_number" />
      </a-form-model-item>

      <a-form-model-item ref="address" label="Adres" prop="address">
        <a-textarea v-model="corporation.address" placeholder="Adres" :rows="2" />
      </a-form-model-item>

      <a-form-model-item ref="description" label="Detay" prop="description">
        <a-textarea v-model="corporation.description" placeholder="Detay" :rows="2" />
      </a-form-model-item>

      <a-form-model-item label="Segment" prop="segment_id">
        <a-select
          show-search
          allowClear
          placeholder="Segment seçiniz"
          v-model="corporation.segment_id"
          option-filter-prop="children"
          :filter-option="filterOption"
        >
          <a-select-option v-for="seg in segments" :value="seg.id" :key="seg.id">
            {{ seg.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item label="Konum" :wrapper-col="{ span: 24 }">
        <div class="map-wrapper">
          <gmap-autocomplete @place_changed="setPlace"></gmap-autocomplete>
          <GmapMap
            ref="map"
            :center="mapCenter"
            :zoom="12"
            style="width: 100%; height: 300px"
            @click="mapClicked"
          >
            <GmapMarker v-if="marker"
              :position="marker.position"
              :clickable="true"
              :draggable="false"
              @click="mapCenter = marker.position"
            />
          </GmapMap>
        </div>
      </a-form-model-item>

      <a-form-model-item :wrapper-col="{ span: 14, offset: 5 }">
        <a-button :loading="loading" type="primary" @click="onSubmit">
          Güncelle
        </a-button>
        <a-button style="margin-left: 10px;" @click="resetForm">
          Sıfırla
        </a-button>
      </a-form-model-item>
    </a-form-model>
  </card>
</template>

<script>
import Card from 'src/components/Cards/Card.vue'

export default {
  components: { Card },
  props: ["corporation"],

  mounted() {
    this.$store.dispatch('Segments/requestSegmentIndex').then((res) => {
      this.segments = res.segments || []
    })
    if (this.corporation.location) {
      const location = {
        lat: this.corporation.location.latitude,
        lng: this.corporation.location.longitude,
      }
      this.mapCenter = location
      this.marker = { position: location }
    }
  },

  data() {
    return {
      segments: [],
      loading: false,
      mapCenter: { lat: 41.0082, lng: 28.9784 },
      marker: null,
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
      rules: {
        corporation_name: [
          { required: true, message: 'İşletme Adı alanını boş bırakmayınız', trigger: 'blur' },
          { min: 2, max: 100, message: 'İşletme Adı 2-100 karakter arasında olmalıdır', trigger: 'blur' },
        ],
        owner_name: [
          { required: true, message: 'İşletme Sahibi Adı alanını boş bırakmayınız', trigger: 'blur' },
          { min: 2, max: 100, message: 'İşletme Sahibi Adı 2-100 karakter arasında olmalıdır', trigger: 'blur' },
        ],
        segment_id: [
          { required: true, message: 'Segment seçimi zorunludur', trigger: 'change', type: 'number' },
        ],
      },
    }
  },

  methods: {
    filterOption(input, option) {
      return option.componentOptions.children[0].text
        .toLowerCase()
        .indexOf(input.toLowerCase()) >= 0
    },

    setPlace(place) {
      if (!place.geometry) {
        alert('Lütfen geçerli bir yer seçin!')
        return
      }
      const location = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
      }
      this.mapCenter = location
      this.marker = { position: location }
    },

    mapClicked(event) {
      const location = {
        lat: event.latLng.lat(),
        lng: event.latLng.lng(),
      }
      this.marker = { position: location }
    },

    onSubmit() {
      const self = this
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return

        const payload = {
          id: self.corporation.id,
          corporation_name: self.corporation.corporation_name,
          owner_name: self.corporation.owner_name,
          phone_number: self.corporation.phone_number,
          address: self.corporation.address,
          description: self.corporation.description,
          segment_id: self.corporation.segment_id,
          location: self.marker
            ? { latitude: self.marker.position.lat, longitude: self.marker.position.lng }
            : null,
        }

        self.loading = true
        self.$store.dispatch('Corporation/requestCorporationUpdate', payload).then(() => {
          self.$notification.success({
            message: 'İşletme Güncelleme',
            description: 'İşletme başarılı bir şekilde güncellendi.',
          })
          self.$router.push('/admin/corporations/')
        }).catch(() => {
          self.$notification.error({
            message: 'İşletme Güncelleme',
            description: 'İşletme güncellenirken bir hata oluştu.',
          })
        }).finally(() => {
          self.loading = false
        })
      })
    },

    resetForm() {
      this.$refs.ruleForm.resetFields()
    },
  },
}
</script>
